import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { commonStyles } from "../../Services/ReactPDFService.jsx";

// Simple ATS Cover Letter Template - Blue name, split header (matches SimpleATS resume)
const styles = StyleSheet.create({
  ...commonStyles,
  page: {
    ...commonStyles.page,
    fontFamily: "Roboto",
    backgroundColor: "#ffffff",
    padding:"40 50",
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 24,
    paddingBottom: 12,
    borderBottom:"1.5pt solid #e5e7eb",
  },
  headerLeft: {
    flex: 1,
  },
  headerRight: {
    alignItems: "flex-end",
    paddingTop: 6,
  },
  name: {
    fontSize: 24,
    fontWeight: 700,
    color: "#3b82f6",
    letterSpacing: 0.3,
    marginBottom: 2,
  },
  contactItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 2,
  },
  contactText: {
    fontSize: 9,
    color: "#555555",
  },
  contactLink: {
    fontSize: 9,
    color: "#3b82f6",
    textDecoration: "underline",
  },
  // Section header - blue text, matches resume
  sectionHeaderContainer: {
    marginTop: 10,
    marginBottom: 0,
    paddingBottom: 3,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: "#3b82f6",
    letterSpacing: 0.3,
    textTransform: "uppercase",
  },
  bodyText: {
    fontSize: 11,
    lineHeight: 1.8,
    color: "#374151",
    textAlign: "justify",
  },
});

const SimpleATSCoverLetter = ({ coverLetterData }) => {
  const { header, generatedContent } = coverLetterData || {};
  const { name, email, phone, location } = header || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerContainer}>
          <View style={styles.headerLeft}>
            <Text style={styles.name}>{name || "[Name]"}</Text>
          </View>
          <View style={styles.headerRight}>
            {email && (
              <View style={styles.contactItem}>
                <Text style={styles.contactLink}>{email}</Text>
              </View>
            )}
            {phone && (
              <View style={styles.contactItem}>
                <Text style={styles.contactText}>{phone}</Text>
              </View>
            )}
            {location && (
              <View style={styles.contactItem}>
                <Text style={styles.contactText}>{location}</Text>
              </View>
            )}
          </View>
        </View>
        <Text style={styles.bodyText}>{generatedContent || "No content generated yet."}</Text>
      </Page>
    </Document>
  );
};

export default SimpleATSCoverLetter;
